import { useContext } from "react";
import Image from "next/image";
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
  Icon,
} from "@chakra-ui/react";
import { MdOutlineContentCopy } from "react-icons/md";
import { HiOutlineExternalLink } from "react-icons/hi";
import { BsClockHistory } from "react-icons/bs";

// Types
import Props from "./AccountModal.type";

// Context
import { StakeContext } from "providers/StakeProvider";

// Utils
import { shortenAddress } from "utils/common";

// Constants
import { VIEW_PAST_TRANSACTIONS } from "constants/analytics";

const AccountModal = ({ isOpen }: Props) => {
  const {
    providerInfo,
    walletInfo,
    handleDisconnect,
    handleAddressCopy,
    handleViewOnEtherScan,
    closeModal,
    openTxnHistoryModal,
    isLedgerApp,
    track,
  } = useContext(StakeContext);
  const { address } = walletInfo;

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent w="394px" bg="brand.backgroundLight">
        <ModalHeader fontSize="1rem">Wallet</ModalHeader>
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        <ModalBody pt="0" mb="0.5rem">
          <Text fontSize="14px">Connected with {providerInfo.name}</Text>
          <Flex
            justifyContent="space-between"
            padding="1rem"
            bg="brand.textBg"
            mt="1rem"
            borderRadius="0.5rem"
          >
            <Flex gap="0.5rem">
              <Image
                src={providerInfo.icon}
                width="24px"
                height="24px"
                alt="provider-icon"
              />
              <Text>{shortenAddress(address)}</Text>
            </Flex>
            {!isLedgerApp && (
              <Box
                color="brand.primary"
                fontFamily="semi-bold"
                cursor="pointer"
                onClick={handleDisconnect}
              >
                Disconnect
              </Box>
            )}
          </Flex>
          <Flex
            justifyContent="space-between"
            padding="1rem 0"
            alignItems="center"
          >
            <Flex
              cursor="pointer"
              color="brand.primary"
              onClick={handleAddressCopy}
              alignItems="center"
              gap="0.5rem"
            >
              <Icon as={MdOutlineContentCopy} />
              <Text fontFamily="medium">Copy Address</Text>
            </Flex>
            <Flex
              cursor="pointer"
              color="brand.primary"
              onClick={handleViewOnEtherScan}
              alignItems="center"
              gap="0.5rem"
            >
              <Icon as={HiOutlineExternalLink} />
              <Text fontFamily="medium">View on Explorer</Text>
            </Flex>
          </Flex>
          <Flex
            cursor="pointer"
            color="brand.primary"
            onClick={() => {
              closeModal();
              track(VIEW_PAST_TRANSACTIONS);
              openTxnHistoryModal();
            }}
            alignItems="center"
            gap="0.5rem"
            mb="0.5rem"
          >
            <Icon as={BsClockHistory} />
            <Text fontFamily="medium">Transactions</Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AccountModal;
